<!-- ? Preloader Start -->
<!--     <div id="preloader-active">
        <div class="preloader d-flex align-items-center justify-content-center">
            <div class="preloader-inner position-relative">
                <div class="preloader-circle"></div>
                <div class="preloader-img pere-text">
                    <img src="resources/img/logo/loder.png" alt="">
                </div>
            </div>
        </div>
    </div> -->
<!-- Preloader Start -->
<!--     <app-header></app-header>
 -->

<!--<app-news></app-news>-->
<!-- <app-chi-siamo></app-chi-siamo> -->
 <app-slider-area></app-slider-area>
<!-- <app-galleria></app-galleria> -->
<app-servizi></app-servizi>
<app-corsi></app-corsi>
<app-team></app-team>
<!-- <app-contattaci></app-contattaci> -->
<app-feedback></app-feedback>
<!-- <app-corsi></app-corsi> -->
<!-- <app-contattaci></app-contattaci> -->

